import { RadioDateFilterOperation } from '@hotjar/global-filters';
import { QueryKeyEnum } from '@hotjar/global-filters/src/domains/global-filters/model/QueryFormat';

import type { RadioDateFilterValue } from '@hotjar/global-filters';
import { toISOStringWithNoTimezone } from '@hotjar/feedback/domain/IncomingFeedback/converters/DateFilter';
import { UserAttributeQueryKind, UserAttributesFilter } from './UserAttributeFilters';
import type {
  UserAttributeClauseNameless,
  UserAttributeWithKindType,
} from './UserAttributeFilters';

const RELATIVE_DATES_LIST: Set<RadioDateFilterOperation> = new Set([
  RadioDateFilterOperation.IS_EXACTLY_DAYS_AGO,
  RadioDateFilterOperation.IS_MORE_THAN_DAYS_AGO,
  RadioDateFilterOperation.IS_LESS_THAN_DAYS_AGO,
]);

export const mapDateUserAttribute = (
  filter: RadioDateFilterValue | undefined,
): UserAttributeClauseNameless => {
  const dateType =
    filter?.operation === undefined || RELATIVE_DATES_LIST.has(filter?.operation)
      ? UserAttributeQueryKind.DATE_RELATIVE
      : UserAttributeQueryKind.DATE_ABSOLUTE;

  const type: UserAttributeWithKindType = `${QueryKeyEnum.user_attributes}.${dateType}`;
  const unit = 'days';

  switch (filter?.operation) {
    case RadioDateFilterOperation.IS_EXACTLY_DAYS_AGO:
      return { type, operation: UserAttributesFilter.EQUALS, value: filter.value, unit };
    case RadioDateFilterOperation.IS_LESS_THAN_DAYS_AGO:
      return { type, operation: UserAttributesFilter.LESS_THAN, value: filter.value, unit };
    case RadioDateFilterOperation.IS_MORE_THAN_DAYS_AGO:
      return { type, operation: UserAttributesFilter.GREATER_THAN, value: filter.value, unit };
    case RadioDateFilterOperation.IS_ON:
      return {
        type,
        operation: UserAttributesFilter.EQUALS,
        value: toISOStringWithNoTimezone(filter.value),
      };
    case RadioDateFilterOperation.IS_BEFORE:
      return {
        type,
        operation: UserAttributesFilter.LESS_THAN,
        value: toISOStringWithNoTimezone(filter.value),
      };
    case RadioDateFilterOperation.IS_AFTER:
      return {
        type,
        operation: UserAttributesFilter.GREATER_THAN,
        value: toISOStringWithNoTimezone(filter.value),
      };
    case RadioDateFilterOperation.IS_UNKNOWN:
      return { type, operation: UserAttributesFilter.IS_UNKNOWN };
    case RadioDateFilterOperation.HAS_ANY_VALUE:
    default:
      return { type, operation: UserAttributesFilter.HAS_ANY_VALUE };
  }
};
